const getAppId = () =>
  String(
    process.env.REACT_APP_FACEBOOK_APP_ID ||
      process.env.REACT_APP_META_APP_ID ||
      ""
  ).trim();

const getConfigId = () =>
  String(
    process.env.REACT_APP_WHATSAPP_EMBEDDED_SIGNUP_CONFIG_ID ||
      process.env.REACT_APP_WHATSAPP_CONFIG_ID ||
      ""
  ).trim();

export const getWhatsAppEmbeddedSignupMissingVars = () => {
  const missing = [];
  if (!getAppId()) missing.push("REACT_APP_FACEBOOK_APP_ID");
  if (!getConfigId()) missing.push("REACT_APP_WHATSAPP_EMBEDDED_SIGNUP_CONFIG_ID");
  return missing;
};

export const isWhatsAppEmbeddedSignupConfigured = () =>
  getWhatsAppEmbeddedSignupMissingVars().length === 0;

const waitForFacebookSdk = (timeoutMs = 8000) =>
  new Promise((resolve, reject) => {
    if (typeof window === "undefined") {
      reject(new Error("Facebook SDK requires a browser"));
      return;
    }
    if (window.FB && typeof window.FB.login === "function") {
      resolve(window.FB);
      return;
    }
    const started = Date.now();
    const timer = setInterval(() => {
      if (window.FB && typeof window.FB.login === "function") {
        clearInterval(timer);
        resolve(window.FB);
      } else if (Date.now() - started > timeoutMs) {
        clearInterval(timer);
        reject(new Error("Facebook SDK did not become ready in time."));
      }
    }, 100);
  });

/**
 * Launch Meta WhatsApp Embedded Signup.
 * Uses window.launchWhatsAppSignup from index.html (Meta's exact FB.login pattern)
 * so config_id is never dropped by the React bundle.
 */
export const launchWhatsAppEmbeddedSignup = () =>
  new Promise(async (resolve, reject) => {
    const configId = getConfigId();
    if (!configId) {
      reject(
        new Error(
          "Missing REACT_APP_WHATSAPP_EMBEDDED_SIGNUP_CONFIG_ID for Embedded Signup."
        )
      );
      return;
    }

    // Keep index.html launchWhatsAppSignup in sync with env
    if (typeof window !== "undefined") {
      window.__WA_ES_APP_ID__ = getAppId();
      window.__WA_ES_CONFIG_ID__ = configId;
    }

    try {
      await waitForFacebookSdk();
    } catch (err) {
      reject(err);
      return;
    }

    if (typeof window.launchWhatsAppSignup !== "function") {
      reject(
        new Error(
          "window.launchWhatsAppSignup is missing. Hard-refresh the page."
        )
      );
      return;
    }

    window.launchWhatsAppSignup(({ response, session, error }) => {
      if (error) {
        reject(new Error(String(error)));
        return;
      }
      const code = response?.authResponse?.code;
      if (code) {
        resolve({
          code,
          session: session || null,
          wabaId: session?.data?.waba_id || null,
          phoneNumberId: session?.data?.phone_number_id || null,
        });
        return;
      }
      reject(
        new Error(
          response?.error_message ||
            response?.error ||
            "WhatsApp Embedded Signup was cancelled or not completed."
        )
      );
    });
  });
